var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_441_1328",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 33,
    height: 33
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.790039,
    y: 0.318359,
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_441_1328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.01224 26.0961H8.62334L23.4567 11.285L21.8456 9.67388L7.01224 24.485V26.0961ZM4.79004 28.3183V23.585L23.4345 4.97391C23.6419 4.77391 23.8808 4.61835 24.1512 4.50724C24.4216 4.39613 24.7049 4.34058 25.0012 4.34058C25.2827 4.34058 25.5604 4.39613 25.8345 4.50724C26.1086 4.61835 26.353 4.77761 26.5678 4.98501L28.1567 6.58501C28.3789 6.79981 28.54 7.04425 28.64 7.31834C28.74 7.59241 28.79 7.86648 28.79 8.14054C28.79 8.42203 28.7363 8.70167 28.6289 8.97944C28.5215 9.2572 28.3641 9.49979 28.1567 9.70721L9.52334 28.3183H4.79004ZM22.6456 10.485L21.8456 9.67388L23.4567 11.285L22.6456 10.485Z",
    fill: "#283856"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.65625a4912118f5052303242f6f9a1c4.svg";
export { ForwardRef as ReactComponent };